/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
  Paper,
  Chip,
  Divider
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DescriptionIcon from "@material-ui/icons/Description";
import PrintIcon from "@material-ui/icons/Print";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import PersonIcon from "@material-ui/icons/Person";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import EventNoteIcon from "@material-ui/icons/EventNote";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import LockIcon from "@material-ui/icons/Lock";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import TrendingDownIcon from "@material-ui/icons/TrendingDown";

import { SalaryService } from "_services/salary.service";
import SalarySlipDialog from "./SalarySlipDialog";

const fiscalMonths = [
  { val: 10, name: "ตุลาคม", short: "ต.ค." },
  { val: 11, name: "พฤศจิกายน", short: "พ.ย." },
  { val: 12, name: "ธันวาคม", short: "ธ.ค." },
  { val: 1, name: "มกราคม", short: "ม.ค." },
  { val: 2, name: "กุมภาพันธ์", short: "ก.พ." },
  { val: 3, name: "มีนาคม", short: "มี.ค." },
  { val: 4, name: "เมษายน", short: "เม.ย." },
  { val: 5, name: "พฤษภาคม", short: "พ.ค." },
  { val: 6, name: "มิถุนายน", short: "มิ.ย." },
  { val: 7, name: "กรกฎาคม", short: "ก.ค." },
  { val: 8, name: "สิงหาคม", short: "ส.ค." },
  { val: 9, name: "กันยายน", short: "ก.ย." }
];

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    fontFamily: '"Sarabun", "Tahoma", sans-serif',
    [theme.breakpoints.down("sm")]: {
      marginLeft: "-15px !important",
      marginRight: "-15px !important",
      width: "calc(100% + 30px) !important",
      maxWidth: "calc(100% + 30px) !important",
      paddingLeft: "15px !important",
      paddingRight: "15px !important",
      paddingTop: "6px !important",
      paddingBottom: "16px !important",
      boxSizing: "border-box"
    }
  },
  header: {
    marginBottom: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      marginBottom: theme.spacing(1.5),
      gap: theme.spacing(1)
    }
  },
  title: {
    fontWeight: "bold",
    color: "#1e293b",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.25rem"
    }
  },
  filterCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    [theme.breakpoints.down("xs")]: {
      marginBottom: theme.spacing(2)
    }
  },
  filterCardContent: {
    padding: "16px 20px",
    [theme.breakpoints.down("xs")]: {
      padding: "12px 10px"
    }
  },
  monthPill: {
    margin: theme.spacing(0.5),
    fontWeight: "bold",
    cursor: "pointer"
  },

  /* Responsive visibility */
  desktopOnly: {
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none !important"
    },
    "@media print": {
      display: "block !important"
    }
  },
  mobileOnly: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block !important"
    },
    "@media print": {
      display: "none !important"
    }
  },

  /* Month Selector Grid for Mobile */
  monthGridMobile: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "6px",
    marginTop: "8px"
  },
  monthItemMobile: {
    padding: "7px 4px",
    borderRadius: 6,
    textAlign: "center",
    fontSize: "0.82rem",
    fontWeight: "bold",
    cursor: "pointer",
    border: "1px solid #cbd5e1",
    backgroundColor: "#ffffff",
    color: "#475569",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "3px",
    transition: "all 0.15s ease",
    userSelect: "none"
  },

  /* Desktop Official Pay Slip Paper */
  userCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 8,
    backgroundColor: "#f8fafc",
    border: "1px solid #e2e8f0"
  },
  slipPaper: {
    padding: theme.spacing(4),
    backgroundColor: "#ffffff",
    border: "1px solid #cbd5e1",
    borderRadius: 8,
    boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
    "@media print": {
      boxShadow: "none",
      border: "none",
      padding: 0,
      margin: 0
    }
  },
  slipTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "1.3rem",
    color: "#0f172a"
  },
  slipSubTitle: {
    textAlign: "center",
    fontSize: "1.05rem",
    color: "#334155",
    marginBottom: theme.spacing(2)
  },
  infoBox: {
    border: "1px solid #cbd5e1",
    borderRadius: 6,
    padding: "10px 16px",
    backgroundColor: "#f8fafc",
    marginBottom: theme.spacing(2.5)
  },
  tableCol: {
    border: "1px solid #475569",
    borderRadius: 4,
    height: "100%",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column"
  },
  tableHeader: {
    backgroundColor: "#f6f8dc",
    padding: "8px 14px",
    fontWeight: "bold",
    borderBottom: "1px solid #475569",
    textAlign: "center",
    color: "#0f172a"
  },
  itemRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 14px",
    borderBottom: "1px dotted #e2e8f0",
    fontSize: "0.92rem",
    "&:nth-of-type(even)": {
      backgroundColor: "#fafafa"
    }
  },
  totalRow: {
    marginTop: "auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 14px",
    backgroundColor: "#f8fafc",
    borderTop: "1px solid #475569",
    fontWeight: "bold",
    fontSize: "1rem"
  },
  tableTotalRow: {
    marginTop: "auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 14px",
    backgroundColor: "#f8fafc",
    borderTop: "1px solid #475569",
    fontWeight: "bold",
    fontSize: "1rem"
  },
  netPayBox: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: "#ecfdf5",
    border: "2px solid #10b981",
    borderRadius: 8,
    textAlign: "center"
  },

  /* Mobile Specific Styles (Sleek Vertical Smartphone View) */
  mobileHeroCard: {
    backgroundColor: "#ffffff",
    border: "1.5px solid #10b981",
    borderRadius: 12,
    padding: "14px 16px",
    marginBottom: theme.spacing(1.5),
    boxShadow: "0 2px 10px rgba(16, 185, 129, 0.08)"
  },
  mobileHeroHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px"
  },
  mobileHeroMonthBadge: {
    fontSize: "0.82rem",
    fontWeight: "bold",
    color: "#065f46",
    backgroundColor: "#d1fae5",
    padding: "3px 8px",
    borderRadius: "6px"
  },
  mobileHeroLabel: {
    display: "block",
    color: "#64748b",
    fontSize: "0.8rem",
    fontWeight: 600,
    marginBottom: "2px"
  },
  mobileHeroAmount: {
    fontSize: "1.85rem",
    fontWeight: "bold",
    color: "#047857",
    lineHeight: 1.2,
    marginBottom: "8px",
    letterSpacing: "-0.5px"
  },
  mobileHeroBankInfo: {
    display: "flex",
    alignItems: "center",
    fontSize: "0.78rem",
    color: "#334155",
    paddingTop: "6px",
    borderTop: "1px dashed #d1fae5"
  },
  mobileStatCardIncome: {
    backgroundColor: "#f0fdf4",
    border: "1px solid #86efac",
    borderRadius: 8,
    padding: "10px 12px"
  },
  mobileStatCardOutcome: {
    backgroundColor: "#fff1f2",
    border: "1px solid #fecdd3",
    borderRadius: 8,
    padding: "10px 12px"
  },
  mobileStatAmountIncome: {
    fontWeight: "bold",
    fontSize: "1.02rem",
    color: "#15803d",
    lineHeight: 1.2,
    marginTop: "2px"
  },
  mobileStatAmountOutcome: {
    fontWeight: "bold",
    fontSize: "1.02rem",
    color: "#be123c",
    lineHeight: 1.2,
    marginTop: "2px"
  },
  mobileSectionCard: {
    borderRadius: 10,
    marginBottom: theme.spacing(1.5),
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
    overflow: "hidden"
  },
  mobileSectionHeaderIncome: {
    backgroundColor: "#ecfdf5",
    padding: "9px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #a7f3d0"
  },
  mobileSectionHeaderOutcome: {
    backgroundColor: "#fef2f2",
    padding: "9px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #fecaca"
  },
  mobileItemRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "9px 12px",
    borderBottom: "1px solid #f1f5f9",
    "&:last-child": {
      borderBottom: "none"
    }
  },
  mobileItemName: {
    fontSize: "0.85rem",
    color: "#1e293b",
    flex: 1,
    paddingRight: "8px",
    lineHeight: 1.3
  },
  mobileItemAmountIncome: {
    fontSize: "0.88rem",
    fontWeight: "bold",
    color: "#15803d",
    whiteSpace: "nowrap"
  },
  mobileItemAmountOutcome: {
    fontSize: "0.88rem",
    fontWeight: "bold",
    color: "#be123c",
    whiteSpace: "nowrap"
  },
  mobileSectionFooterIncome: {
    backgroundColor: "#f8fafc",
    borderTop: "1px solid #e2e8f0",
    padding: "8px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "bold",
    fontSize: "0.85rem",
    color: "#15803d"
  },
  mobileSectionFooterOutcome: {
    backgroundColor: "#f8fafc",
    borderTop: "1px solid #e2e8f0",
    padding: "8px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "bold",
    fontSize: "0.85rem",
    color: "#be123c"
  },
  mobileEmployeeCard: {
    backgroundColor: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: 10,
    padding: "12px 14px",
    marginBottom: theme.spacing(1.5)
  },
  mobileEmpInfoRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "0.8rem",
    marginBottom: "5px",
    "&:last-child": {
      marginBottom: 0
    }
  },
  mobileEmpLabel: {
    color: "#64748b",
    whiteSpace: "nowrap",
    marginRight: "8px"
  },
  mobileEmpVal: {
    color: "#1e293b",
    fontWeight: 500,
    textAlign: "right",
    wordBreak: "break-word"
  },

  noPrint: {
    "@media print": {
      display: "none !important"
    }
  }
}));

export default function MySalarySlip() {
  const classes = useStyles();

  const now = new Date();
  const currentYearBE = now.getFullYear() + 543;
  const currentMonth = now.getMonth() + 1;
  const currentFiscalYear = currentMonth >= 10 ? currentYearBE + 1 : currentYearBE;

  const [fiscalYear, setFiscalYear] = useState(currentFiscalYear);
  const [calMonth, setCalMonth] = useState(currentMonth);
  const [availableMonths, setAvailableMonths] = useState([]);
  const [loading, setLoading] = useState(false);
  const [slip, setSlip] = useState(null);
  const [slipDialogOpen, setSlipDialogOpen] = useState(false);

  // Retrieve current user
  const currentUser = (() => {
    try {
      const u = localStorage.getItem("currentUser");
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  })();

  const currentUserName =
    currentUser?.userName || currentUser?.userView?.userName || currentUser?.UserID || "";

  // Available Fiscal Years
  const fiscalYears = Array.from(
    new Set([
      currentFiscalYear + 1,
      currentFiscalYear,
      currentFiscalYear - 1,
      currentFiscalYear - 2,
      currentFiscalYear - 3,
      2568,
      2567,
      2566,
      2565,
      2564
    ])
  ).sort((a, b) => b - a);

  const queryYear = calMonth >= 10 ? fiscalYear - 1 : fiscalYear;

  useEffect(() => {
    if (fiscalYear) {
      loadAvailableMonths();
    }
  }, [fiscalYear]);

  useEffect(() => {
    if (fiscalYear && calMonth) {
      loadSlip();
    }
  }, [fiscalYear, calMonth]);

  const loadAvailableMonths = async () => {
    try {
      const prevYear = fiscalYear - 1;
      const currYear = fiscalYear;
      const [resPrev, resCurr] = await Promise.all([
        SalaryService.getMySlipMonths(prevYear, currentUserName),
        SalaryService.getMySlipMonths(currYear, currentUserName)
      ]);
      const monthsPrev =
        resPrev.data && resPrev.data.success && Array.isArray(resPrev.data.data)
          ? resPrev.data.data.filter(m => m >= 10)
          : [];
      const monthsCurr =
        resCurr.data && resCurr.data.success && Array.isArray(resCurr.data.data)
          ? resCurr.data.data.filter(m => m <= 9)
          : [];
      const avail = [...monthsPrev, ...monthsCurr];
      setAvailableMonths(avail);

      // Auto-select latest available month if current calMonth is not available
      if (avail.length > 0 && !avail.includes(calMonth)) {
        const sortedAvail = fiscalMonths.filter(m => avail.includes(m.val));
        if (sortedAvail.length > 0) {
          setCalMonth(sortedAvail[sortedAvail.length - 1].val);
        }
      }
    } catch (err) {
      console.error("Error loading available slip months:", err);
    }
  };

  const loadSlip = async () => {
    setLoading(true);
    setSlip(null);
    try {
      const qYear = calMonth >= 10 ? fiscalYear - 1 : fiscalYear;
      const res = await SalaryService.getMySlip(qYear, calMonth, currentUserName);
      if (res.data && res.data.success && res.data.data) {
        setSlip(res.data.data);
      }
    } catch (err) {
      console.error("Error loading slip:", err);
    } finally {
      setLoading(false);
    }
  };

  const monthObj = fiscalMonths.find(m => m.val === calMonth) || { name: `${calMonth}` };
  const isSlipApproved = Boolean(
    slip && (slip.isApproved === true || slip.approve === "y" || slip.approve === "Y")
  );

  return (
    <div className={classes.root}>
      {/* Top Header */}
      <div className={`${classes.header} ${classes.noPrint}`}>
        <div>
          <Typography variant="h5" className={classes.title}>
            <DescriptionIcon fontSize="large" style={{ color: "#2563eb" }} /> สลิปเงินเดือน (Pay Slip)
          </Typography>
          <Typography variant="body2" color="textSecondary">
            ตรวจสอบข้อมูลรายรับ-รายจ่าย และพิมพ์สลิปเงินเดือนย้อนหลังรายเดือนของตนเอง
          </Typography>
        </div>

        {slip && isSlipApproved && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<PrintIcon />}
            onClick={() => setSlipDialogOpen(true)}
            style={{ backgroundColor: "#2563eb" }}
          >
            พิมพ์สลิปเงินเดือน
          </Button>
        )}
      </div>

      {/* Filter Toolbar (Hidden on print) */}
      <Card variant="outlined" className={`${classes.filterCard} ${classes.noPrint}`}>
        <CardContent className={classes.filterCardContent}>
          {/* Desktop Filter Toolbar (Horizontal chips selector) */}
          <div className={classes.desktopOnly}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={3} md={2}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="ปีงบประมาณ"
                  value={fiscalYear}
                  onChange={e => setFiscalYear(Number(e.target.value))}
                >
                  {fiscalYears.map(y => (
                    <MenuItem key={y} value={y}>
                      ปีงบประมาณ {y}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={9} md={10}>
                <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                  เลือกเดือนประจำปีงบประมาณ {fiscalYear} (ปุ่มสีเขียวคือเดือนที่ข้อมูลเงินเดือนอนุมัติแล้ว):
                </Typography>

                <Box display="flex" flexWrap="wrap" alignItems="center">
                  {fiscalMonths.map(m => {
                    const hasData = availableMonths.includes(m.val);
                    const isSelected = calMonth === m.val;
                    const calYearOfM = m.val >= 10 ? fiscalYear - 1 : fiscalYear;

                    return (
                      <Chip
                        key={m.val}
                        label={`${m.name} ${calYearOfM}`}
                        onClick={() => setCalMonth(m.val)}
                        color={isSelected ? "primary" : hasData ? "default" : "default"}
                        variant={isSelected ? "default" : "outlined"}
                        className={classes.monthPill}
                        style={{
                          backgroundColor: isSelected
                            ? "#2563eb"
                            : hasData
                            ? "#dcfce7"
                            : undefined,
                          borderColor: isSelected
                            ? "#2563eb"
                            : hasData
                            ? "#10b981"
                            : "#cbd5e1",
                          color: isSelected
                            ? "#ffffff"
                            : hasData
                            ? "#065f46"
                            : "#64748b",
                          fontWeight: isSelected || hasData ? "bold" : "normal"
                        }}
                        icon={
                          hasData ? (
                            <CheckCircleIcon
                              style={{
                                fontSize: 16,
                                color: isSelected ? "#ffffff" : "#10b981"
                              }}
                            />
                          ) : undefined
                        }
                      />
                    );
                  })}
                </Box>
              </Grid>
            </Grid>
          </div>

          {/* Smartphone Filter Toolbar (Year + Month Combobox side-by-side) */}
          <div className={classes.mobileOnly}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={5}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="ปีงบประมาณ"
                  value={fiscalYear}
                  onChange={e => setFiscalYear(Number(e.target.value))}
                >
                  {fiscalYears.map(y => (
                    <MenuItem key={y} value={y}>
                      ปี {y}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={7}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="ประจำเดือน"
                  value={calMonth}
                  onChange={e => setCalMonth(Number(e.target.value))}
                  SelectProps={{
                    renderValue: selected => {
                      const m = fiscalMonths.find(item => item.val === selected);
                      const hasData = availableMonths.includes(selected);
                      const calYearOfSelected = selected >= 10 ? fiscalYear - 1 : fiscalYear;
                      return (
                        <span style={{ fontWeight: hasData ? "bold" : "normal", color: hasData ? "#065f46" : "#1e293b" }}>
                          {m ? `${m.name} ${calYearOfSelected}` : selected} {hasData ? "✓" : ""}
                        </span>
                      );
                    }
                  }}
                >
                  {fiscalMonths.map(m => {
                    const hasData = availableMonths.includes(m.val);
                    const calYearOfM = m.val >= 10 ? fiscalYear - 1 : fiscalYear;
                    return (
                      <MenuItem
                        key={`mob-month-${m.val}`}
                        value={m.val}
                        disabled={!hasData}
                        style={{
                          fontSize: "0.9rem",
                          padding: "9px 14px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center"
                        }}
                      >
                        <span style={{ fontWeight: hasData ? "bold" : "normal", color: hasData ? "#0f172a" : "#94a3b8" }}>
                          {m.name} {calYearOfM}
                        </span>
                        {hasData ? (
                          <span
                            style={{
                              fontSize: "0.72rem",
                              backgroundColor: "#dcfce7",
                              color: "#166534",
                              padding: "2px 6px",
                              borderRadius: 4,
                              fontWeight: "bold",
                              marginLeft: 8
                            }}
                          >
                            อนุมัติแล้ว
                          </span>
                        ) : (
                          <span
                            style={{
                              fontSize: "0.72rem",
                              color: "#94a3b8",
                              marginLeft: 8
                            }}
                          >
                            ไม่มีข้อมูล
                          </span>
                        )}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
            </Grid>
          </div>
        </CardContent>
      </Card>

      {/* Slip Content or Empty/Loading State */}
      {loading ? (
        <Box py={8} textAlign="center" className={classes.noPrint}>
          <CircularProgress style={{ color: "#2563eb" }} />
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
            กำลังโหลดข้อมูลสลิปเงินเดือน ประจำเดือน{monthObj.name} พ.ศ. {queryYear} (ปีงบประมาณ {fiscalYear})...
          </Typography>
        </Box>
      ) : slip && isSlipApproved ? (
        <>
          {/* ========================================================= */}
          {/* 1. DESKTOP VIEW (WINDOWS / TABLET LANDSCAPE >= 960px)     */}
          {/* Exactly unchanged as requested ("UI สำหรับ Windows สวยงามมากแล้ว") */}
          {/* ========================================================= */}
          <div className={classes.desktopOnly}>
            {/* Quick KPI Overview (Hidden on print) */}
            <Grid container spacing={2} className={`${classes.userCard} ${classes.noPrint}`} style={{ padding: 12 }}>
              <Grid item xs={12} sm={4}>
                <Card variant="outlined" style={{ backgroundColor: "#f0fdf4", borderColor: "#86efac" }}>
                  <CardContent style={{ padding: "12px 16px" }}>
                    <Typography variant="caption" style={{ color: "#166534", fontWeight: "bold" }}>
                      ยอดรายได้รวม (Total Income)
                    </Typography>
                    <Typography variant="h5" style={{ color: "#15803d", fontWeight: "bold", marginTop: 4 }}>
                      ฿{slip.totalIncome.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Card variant="outlined" style={{ backgroundColor: "#fff1f2", borderColor: "#fecdd3" }}>
                  <CardContent style={{ padding: "12px 16px" }}>
                    <Typography variant="caption" style={{ color: "#9f1239", fontWeight: "bold" }}>
                      ยอดรายการหักรวม (Total Outcome)
                    </Typography>
                    <Typography variant="h5" style={{ color: "#be123c", fontWeight: "bold", marginTop: 4 }}>
                      ฿{slip.totalOutcome.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Card variant="outlined" style={{ backgroundColor: "#eff6ff", borderColor: "#bfdbfe" }}>
                  <CardContent style={{ padding: "12px 16px" }}>
                    <Typography variant="caption" style={{ color: "#1e40af", fontWeight: "bold" }}>
                      ยอดรับสุทธิ (Net Salary)
                    </Typography>
                    <Typography variant="h5" style={{ color: "#1d4ed8", fontWeight: "bold", marginTop: 4 }}>
                      ฿{slip.netSalary.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Official Printable Pay Slip Paper */}
            <Paper className={classes.slipPaper}>
              {/* Header */}
              <Typography className={classes.slipTitle}>
                โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
              </Typography>
              <Typography className={classes.slipSubTitle} style={{ fontWeight: "bold", marginBottom: 4 }}>
                ใบรับรองการจ่ายเงินเดือน-ค่าจ้างประจำและเงินอื่นๆ
              </Typography>
              <Typography variant="body2" style={{ textAlign: "right", marginBottom: 12 }}>
                ประจำเดือน {slip.monthName} พ.ศ. {slip.calYear}
              </Typography>

              {/* Employee Information */}
              <div className={classes.infoBox}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                      <strong>ชื่อ-นามสกุล:</strong> {slip.fullName}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                      <strong>เลขบัตรประชาชน:</strong> {slip.identificationID || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                      <strong>ตำแหน่ง:</strong> {slip.positionName || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                      <strong>โอนเข้าบัญชี:</strong> {slip.bankName || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                      <strong>หน่วยงาน:</strong> โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง กรมการแพทย์
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                      <strong>เลขที่บัญชี:</strong> {slip.accountNo || "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </div>

              {/* Salary Breakdown (2 Columns: Incomes vs Outcomes) */}
              <Grid container spacing={2}>
                {/* Income Column */}
                <Grid item xs={12} md={6}>
                  <div className={classes.tableCol}>
                    <div className={classes.tableHeader}>รายการได้ (Income)</div>
                    <div style={{ flexGrow: 1, minHeight: 200 }}>
                      {slip.incomes && slip.incomes.length > 0 ? (
                        slip.incomes.map((item, idx) => (
                          <div key={idx} className={classes.itemRow}>
                            <span>{item.name}</span>
                            <span style={{ fontWeight: 500 }}>
                              {item.value.toLocaleString("th-TH", {
                                minimumFractionDigits: 2
                              })}
                            </span>
                          </div>
                        ))
                      ) : (
                        <Box p={2} textAlign="center" color="textSecondary">
                          <Typography variant="caption">ไม่มีรายการได้</Typography>
                        </Box>
                      )}
                    </div>
                    <div className={classes.tableTotalRow}>
                      <span>รวมเงินได้ทั้งสิ้น</span>
                      <span style={{ color: "#15803d" }}>
                        {slip.totalIncome.toLocaleString("th-TH", {
                          minimumFractionDigits: 2
                        })}{" "}
                        บาท
                      </span>
                    </div>
                  </div>
                </Grid>

                {/* Outcome Column */}
                <Grid item xs={12} md={6}>
                  <div className={classes.tableCol}>
                    <div className={classes.tableHeader}>รายการหัก (Deduction)</div>
                    <div style={{ flexGrow: 1, minHeight: 200 }}>
                      {slip.outcomes && slip.outcomes.length > 0 ? (
                        slip.outcomes.map((item, idx) => (
                          <div key={idx} className={classes.itemRow}>
                            <span>{item.name}</span>
                            <span style={{ fontWeight: 500 }}>
                              {item.value.toLocaleString("th-TH", {
                                minimumFractionDigits: 2
                              })}
                            </span>
                          </div>
                        ))
                      ) : (
                        <Box p={2} textAlign="center" color="textSecondary">
                          <Typography variant="caption">ไม่มีรายการหัก</Typography>
                        </Box>
                      )}
                    </div>
                    <div className={classes.tableTotalRow}>
                      <span>รวมรายการหักทั้งสิ้น</span>
                      <span style={{ color: "#be123c" }}>
                        {slip.totalOutcome.toLocaleString("th-TH", {
                          minimumFractionDigits: 2
                        })}{" "}
                        บาท
                      </span>
                    </div>
                  </div>
                </Grid>
              </Grid>

              {/* Net Salary Box */}
              <div className={classes.netPayBox}>
                <Typography variant="body1" style={{ color: "#065f46" }}>
                  จำนวนเงินรับสุทธิ (Net Salary)
                </Typography>
                <Typography variant="h4" style={{ fontWeight: "bold", color: "#047857", margin: "6px 0" }}>
                  ฿{slip.netSalary.toLocaleString("th-TH", { minimumFractionDigits: 2 })} บาท
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  (โอนเข้าบัญชีธนาคาร {slip.bankName} เลขที่ {slip.accountNo})
                </Typography>
              </div>

              {/* Signature */}
              <Box mt={3} pt={1} textAlign="center">
                <Typography variant="body2" style={{ fontFamily: '"TH Sarabun New", "Sarabun", "Tahoma", sans-serif', fontSize: "14pt" }}>
                  ลงชื่อ......................................................ผู้จ่ายเงิน
                </Typography>
                <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 4, fontFamily: '"TH Sarabun New", "Sarabun", "Tahoma", sans-serif', fontSize: "14pt" }}>
                  (......................................................)
                </Typography>
              </Box>

              {/* Slip Footer */}
              <Box mt={3} pt={2} display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="caption" color="textSecondary">
                  เอกสารนี้พิมพ์จากระบบสารสนเทศอัตโนมัติ วันที่พิมพ์: {slip.printDate}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  ฝ่ายการเงินและบัญชี โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้
                </Typography>
              </Box>
            </Paper>
          </div>

          {/* ========================================================= */}
          {/* 2. SMARTPHONE VIEW (จอแนวตั้ง Mobile-First, ไม่โดนบีบอัด)   */}
          {/* ========================================================= */}
          <div className={`${classes.mobileOnly} ${classes.noPrint}`}>
            {/* 1. Mobile Hero: Net Salary Card (เด่น ชัด กระชับ) */}
            <Card variant="outlined" className={classes.mobileHeroCard}>
              <div className={classes.mobileHeroHeader}>
                <span className={classes.mobileHeroMonthBadge}>
                  เดือน{slip.monthName} พ.ศ. {slip.calYear}
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 3,
                    backgroundColor: "#ecfdf5",
                    color: "#065f46",
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                    padding: "3px 8px",
                    borderRadius: 12
                  }}
                >
                  <CheckCircleIcon style={{ fontSize: 13, color: "#10b981" }} />
                  อนุมัติแล้ว
                </span>
              </div>

              <Typography variant="caption" className={classes.mobileHeroLabel}>
                จำนวนเงินรับสุทธิ (Net Salary)
              </Typography>

              <Typography className={classes.mobileHeroAmount}>
                ฿{slip.netSalary.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
              </Typography>

              <div className={classes.mobileHeroBankInfo}>
                <AccountBalanceIcon style={{ fontSize: 16, color: "#059669", marginRight: 6, flexShrink: 0 }} />
                <span>
                  โอนเข้า: <strong>{slip.bankName || "ธนาคาร"}</strong> {slip.accountNo ? `เลขที่ ${slip.accountNo}` : ""}
                </span>
              </div>
            </Card>

            {/* 2. Quick Stat Strip: รายได้รวม vs รายการหักรวม */}
            <Grid container spacing={1} style={{ marginBottom: 12 }}>
              <Grid item xs={6}>
                <Card variant="outlined" className={classes.mobileStatCardIncome}>
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    <TrendingUpIcon style={{ fontSize: 16, color: "#16a34a" }} />
                    <Typography variant="caption" style={{ color: "#166534", fontWeight: "bold" }}>
                      รายได้รวม
                    </Typography>
                  </div>
                  <Typography className={classes.mobileStatAmountIncome}>
                    +฿{slip.totalIncome.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                  </Typography>
                  <Typography variant="caption" style={{ color: "#4d7c0f", fontSize: "0.7rem", display: "block" }}>
                    ({slip.incomes?.length || 0} รายการ)
                  </Typography>
                </Card>
              </Grid>

              <Grid item xs={6}>
                <Card variant="outlined" className={classes.mobileStatCardOutcome}>
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    <TrendingDownIcon style={{ fontSize: 16, color: "#dc2626" }} />
                    <Typography variant="caption" style={{ color: "#991b1b", fontWeight: "bold" }}>
                      รายการหักรวม
                    </Typography>
                  </div>
                  <Typography className={classes.mobileStatAmountOutcome}>
                    -฿{slip.totalOutcome.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                  </Typography>
                  <Typography variant="caption" style={{ color: "#b91c1c", fontSize: "0.7rem", display: "block" }}>
                    ({slip.outcomes?.length || 0} รายการ)
                  </Typography>
                </Card>
              </Grid>
            </Grid>

            {/* 3. Incomes List Card */}
            <Card variant="outlined" className={classes.mobileSectionCard}>
              <div className={classes.mobileSectionHeaderIncome}>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <MonetizationOnIcon style={{ fontSize: 17, color: "#16a34a" }} />
                  <span style={{ fontWeight: "bold", fontSize: "0.9rem", color: "#14532d" }}>
                    รายการได้ (Income)
                  </span>
                </div>
                <span style={{ fontWeight: "bold", fontSize: "0.9rem", color: "#15803d" }}>
                  +฿{slip.totalIncome.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                </span>
              </div>

              <div>
                {slip.incomes && slip.incomes.length > 0 ? (
                  slip.incomes.map((item, idx) => (
                    <div key={`mob-inc-${idx}`} className={classes.mobileItemRow}>
                      <span className={classes.mobileItemName}>{item.name}</span>
                      <span className={classes.mobileItemAmountIncome}>
                        +{item.value.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                      </span>
                    </div>
                  ))
                ) : (
                  <Box p={2} textAlign="center" color="textSecondary">
                    <Typography variant="caption">ไม่มีรายการได้</Typography>
                  </Box>
                )}
              </div>

              <div className={classes.mobileSectionFooterIncome}>
                <span>รวมเงินได้ทั้งสิ้น</span>
                <span>
                  {slip.totalIncome.toLocaleString("th-TH", { minimumFractionDigits: 2 })} บาท
                </span>
              </div>
            </Card>

            {/* 4. Outcomes List Card */}
            <Card variant="outlined" className={classes.mobileSectionCard}>
              <div className={classes.mobileSectionHeaderOutcome}>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <MonetizationOnIcon style={{ fontSize: 17, color: "#dc2626" }} />
                  <span style={{ fontWeight: "bold", fontSize: "0.9rem", color: "#7f1d1d" }}>
                    รายการหัก (Deduction)
                  </span>
                </div>
                <span style={{ fontWeight: "bold", fontSize: "0.9rem", color: "#be123c" }}>
                  -฿{slip.totalOutcome.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                </span>
              </div>

              <div>
                {slip.outcomes && slip.outcomes.length > 0 ? (
                  slip.outcomes.map((item, idx) => (
                    <div key={`mob-out-${idx}`} className={classes.mobileItemRow}>
                      <span className={classes.mobileItemName}>{item.name}</span>
                      <span className={classes.mobileItemAmountOutcome}>
                        -{item.value.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                      </span>
                    </div>
                  ))
                ) : (
                  <Box p={2} textAlign="center" color="textSecondary">
                    <Typography variant="caption">ไม่มีรายการหัก</Typography>
                  </Box>
                )}
              </div>

              <div className={classes.mobileSectionFooterOutcome}>
                <span>รวมรายการหักทั้งสิ้น</span>
                <span>
                  {slip.totalOutcome.toLocaleString("th-TH", { minimumFractionDigits: 2 })} บาท
                </span>
              </div>
            </Card>

            {/* 5. Employee Info (ข้อมูลผู้รับเงินแบบ Compact) */}
            <Card variant="outlined" className={classes.mobileEmployeeCard}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8, borderBottom: "1px solid #e2e8f0", paddingBottom: 6 }}>
                <PersonIcon style={{ fontSize: 18, color: "#2563eb" }} />
                <span style={{ fontWeight: "bold", fontSize: "0.88rem", color: "#1e293b" }}>
                  ข้อมูลผู้รับเงิน
                </span>
              </div>
              <div className={classes.mobileEmpInfoRow}>
                <span className={classes.mobileEmpLabel}>ชื่อ-นามสกุล:</span>
                <span className={classes.mobileEmpVal}>{slip.fullName}</span>
              </div>
              <div className={classes.mobileEmpInfoRow}>
                <span className={classes.mobileEmpLabel}>ตำแหน่ง:</span>
                <span className={classes.mobileEmpVal}>{slip.positionName || "-"}</span>
              </div>
              <div className={classes.mobileEmpInfoRow}>
                <span className={classes.mobileEmpLabel}>เลขบัตร ปชช.:</span>
                <span className={classes.mobileEmpVal}>{slip.identificationID || "-"}</span>
              </div>
              <div className={classes.mobileEmpInfoRow}>
                <span className={classes.mobileEmpLabel}>โอนเข้าบัญชี:</span>
                <span className={classes.mobileEmpVal}>{slip.bankName || "-"} ({slip.accountNo || "-"})</span>
              </div>
              <div className={classes.mobileEmpInfoRow}>
                <span className={classes.mobileEmpLabel}>หน่วยงาน:</span>
                <span className={classes.mobileEmpVal}>รพ.โรคผิวหนังเขตร้อนภาคใต้ กรมการแพทย์</span>
              </div>
            </Card>

            {/* 6. Quick Action: Print / PDF Button */}
            <Box mb={2}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                startIcon={<PrintIcon />}
                onClick={() => setSlipDialogOpen(true)}
                style={{
                  backgroundColor: "#2563eb",
                  fontWeight: "bold",
                  borderRadius: 8,
                  padding: "11px 16px",
                  fontSize: "0.95rem",
                  boxShadow: "0 2px 8px rgba(37,99,235,0.25)"
                }}
              >
                พิมพ์สลิปเงินเดือน / PDF (แบบฟอร์ม A4)
              </Button>
              <Typography
                variant="caption"
                color="textSecondary"
                style={{ display: "block", textAlign: "center", marginTop: 8, fontSize: "0.72rem" }}
              >
                เอกสารนี้พิมพ์จากระบบสารสนเทศอัตโนมัติ วันที่พิมพ์: {slip.printDate}
              </Typography>
            </Box>
          </div>
        </>
      ) : slip && !isSlipApproved ? (
        /* Unapproved Salary State */
        <Paper
          variant="outlined"
          style={{
            padding: "36px 16px",
            textAlign: "center",
            backgroundColor: "#fffbeb",
            borderColor: "#fde68a",
            borderRadius: 8
          }}
          data-testid="unapproved-salary-state"
        >
          <LockIcon style={{ fontSize: 56, color: "#f59e0b", marginBottom: 12 }} />
          <Typography variant="h6" style={{ fontWeight: "bold", color: "#b45309" }} gutterBottom>
            ข้อมูลเงินเดือนยังไม่อนุมัติ
          </Typography>
          <Typography variant="body2" style={{ color: "#92400e", maxWidth: 540, margin: "0 auto 10px auto" }}>
            ข้อมูลเงินเดือนประจำเดือน{monthObj.name} พ.ศ. {queryYear} (ปีงบประมาณ {fiscalYear}) ยังไม่ได้รับการอนุมัติจากฝ่ายการเงิน
          </Typography>
          <Typography variant="caption" style={{ color: "#b45309", display: "block" }}>
            เมื่อฝ่ายการเงินทำการอนุมัติข้อมูลเงินเดือนแล้ว ปุ่มประจำเดือนจะเปลี่ยนเป็นสีเขียวและสามารถพิมพ์สลิปเงินเดือนได้ตามปกติ
          </Typography>
        </Paper>
      ) : (
        /* Empty State */
        <Paper
          variant="outlined"
          style={{
            padding: "36px 16px",
            textAlign: "center",
            backgroundColor: "#ffffff",
            borderColor: "#e2e8f0",
            borderRadius: 8
          }}
          data-testid="empty-salary-state"
        >
          <EventNoteIcon style={{ fontSize: 56, color: "#94a3b8", marginBottom: 12 }} />
          <Typography variant="h6" style={{ fontWeight: "bold", color: "#334155" }} gutterBottom>
            ข้อมูลเงินเดือนยังไม่อนุมัติ
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ maxWidth: 500, margin: "0 auto 16px auto" }}>
            ยังไม่มีการบันทึกหรือประมวลผลข้อมูลเงินเดือนของท่านในเดือนนี้ หรือข้อมูลเงินเดือนยังไม่อนุมัติ
            ท่านสามารถคลิกเลือกเดือนที่มีสัญลักษณ์สีเขียวเพื่อดูสลิปเงินเดือนย้อนหลังได้
          </Typography>

          {availableMonths.length > 0 && (
            <Box mt={1}>
              <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                เดือนที่ข้อมูลเงินเดือนอนุมัติแล้วในปีงบประมาณ {fiscalYear}:
              </Typography>
              <Box display="flex" justifyContent="center" flexWrap="wrap" gap={1} mt={1}>
                {fiscalMonths
                  .filter(m => availableMonths.includes(m.val))
                  .map(m => {
                    const calYearOfM = m.val >= 10 ? fiscalYear - 1 : fiscalYear;
                    return (
                      <Button
                        key={m.val}
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={() => setCalMonth(m.val)}
                        style={{ borderRadius: 20, margin: "3px" }}
                      >
                        ดูสลิปเดือน{m.name} {calYearOfM}
                      </Button>
                    );
                  })}
              </Box>
            </Box>
          )}
        </Paper>
      )}

      {/* Salary Slip Popup Modal (เหมือนหน้า Admin ป้องกันติดเมนูเวลาพิมพ์) */}
      {slipDialogOpen && (
        <SalarySlipDialog
          open={slipDialogOpen}
          onClose={() => setSlipDialogOpen(false)}
          userName={currentUserName}
          calYear={queryYear}
          calMonth={calMonth}
          initialSlip={slip}
        />
      )}
    </div>
  );
}
